<template lang="pug">
li(
  class="nav-item"
  @mouseleave="mouseLeave($event)"
  @mouseover="mouseEnter($event)"
)
  ext-link(
    class="nav-item-link"
    :to="to"
    :external="external"
    :callback="callback"
  )
    span(
      class="nav-item-link-text"
      v-html="textOut"
      :class="{ multiline: Array.isArray(text) && text.length > 1 }"
    )

  items-list(
    v-if="hover"
    :items="items"
    :level="Number(this.level) + 1"
    :max-level="maxLevel"
  )
</template>

<script>
import ExtLink from '@/components/ext/Link.vue'
import ItemsList from './List.vue'

export default {
  components: {
    ExtLink,
    ItemsList,
  },

  props: {
    text: String | Array,
    to: String | Object,
    callback: Function,
    external: Boolean,
    items: Array,
    level: Number,
    maxLevel: Number,
  },

  data() {
    return {
      hover: true
    }
  },

  computed: {
    textOut() {
      return Array.isArray(this.text) ? this.text.join('<br/>') : this.text;
    },

    hasChildren() {
      return Array.isArray(this.items) && this.items.length && (this.maxLevel === undefined || this.nextLevel <= this.maxLevel)
    },
  },

  methods: {
    mouseEnter() {
      this.hover = true;
    },

    mouseLeave() {
      this.hover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-item {
  min-height: 30px;

  .nav-item-link {
    padding: 9px 10px;
    display: inline-block;
    width: 100%;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.85);
    transition: background .1s;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;

    .nav-item-link-text {}

    &:hover {
      background: #d7e0e8;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SubItem.vue?2df08dd5